import React from 'react'

const ArrowBottomIcon = () => (
  <svg
    width="10"
    height="7"
    viewBox="0 0 10 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.833984 1.3335L5.00065 5.50016L9.16732 1.3335"
      stroke="#011533"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default ArrowBottomIcon
